import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";

const BG = "https://images.unsplash.com/photo-1584897356466-858d9b6c53d1?auto=format&fit=crop&w=1600&h=900&q=80";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_token) setDevToken(data.dev_token);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-ink/85" />
      <div className="relative z-10 w-full max-w-md bg-surface/90 backdrop-blur-xl border border-white/10 rounded-2xl p-8 animate-fade-up">
        <Logo size="lg" className="mb-6" />
        <h1 className="font-display text-3xl font-black mb-2">Reset Password</h1>
        {sent ? (
          <div data-testid="forgot-success" className="text-white/80 text-sm space-y-3">
            <p>If an account exists for <b>{email}</b>, a reset link has been sent.</p>
            {devToken && (
              <div className="bg-ink rounded-md p-3 text-xs break-all">
                <p className="text-white/50 mb-1">Dev reset link:</p>
                <Link className="text-gold underline" to={`/reset-password?token=${devToken}`}>/reset-password?token={devToken.slice(0, 16)}...</Link>
              </div>
            )}
            <Link to="/login" className="text-gold inline-block mt-2">Back to sign in</Link>
          </div>
        ) : (
          <>
            <p className="text-white/60 text-sm mb-6">Enter your email and we'll send you a reset link.</p>
            {error && <p className="bg-brand/15 text-brand text-sm rounded-md px-3 py-2 mb-4">{error}</p>}
            <form onSubmit={submit} className="space-y-4">
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-ink border border-white/10 rounded-md px-4 py-3 outline-none focus:ring-1 focus:ring-brand" />
              <button data-testid="forgot-submit" disabled={loading} className="w-full bg-brand hover:bg-brand/90 rounded-md font-semibold py-3 flex items-center justify-center gap-2 disabled:opacity-60">
                {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send Reset Link
              </button>
            </form>
            <Link to="/login" className="text-sm text-white/60 hover:text-white mt-4 inline-block">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
